<template>
    <div class="meetingRoomSetup">
        <div class="leftCont">
            <el-row :gutter="10">
                <el-col span="19">
                    <el-input
                        placeholder="搜索会议室"
                        prefix-icon="el-icon-search"
                        v-model="name"
                        clearable
                        size="small"
                        @clear="meetingRoom"
                        @keydown.enter.native="meetingRoom"
                    >
                    </el-input
                ></el-col>
                <el-col span="2">
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        circle
                        size="small"
                        @click="meetingRoom"
                    ></el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-button
                        type="primary"
                        size="small"
                        style="width:100%;margin-top:20px"
                        @click="addVisible = true"
                        >新增会议室</el-button
                    >
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <div class="status-wrapper">
                        <p class="status-title">会议室标识</p>
                        <el-tooltip
                            content="再次点击可以取消选中状态"
                            placement="top"
                            effect="light"
                        >
                            <div
                                class="status-item"
                                :class="{ 'status-item-active': is_free === 0 }"
                                @click="filterMeeting(0)"
                            >
                                <span class="dot dot-green"></span>
                                <span>闲置</span>
                            </div>
                        </el-tooltip>
                        <div
                            class="status-item"
                            :class="{ 'status-item-active': is_free === 1 }"
                            @click="filterMeeting(1)"
                        >
                            <span class="dot dot-orange"></span>
                            <span>使用中</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <Calendar
                        ref="Calendar"
                        :markDate="markDateArr"
                        v-on:choseDay="clickDay"
                        v-on:changeMonth="changeDate"
                        v-on:isToday="clickToday"
                        :agoDayHide="agoDayHide"
                    ></Calendar>
                </el-col>
            </el-row>
        </div>
        <div class="rightCont">
            <div class="grid-wrap">
                <div class="td-cell" v-for="(item, i) of tableData" :key="i">
                    <p
                        class="td-title text_over_ellipsis"
                        v-if="item.name.length < 15"
                    >
                        {{ item.name }}
                    </p>
                    <el-tooltip
                        effect="light"
                        :content="item.name"
                        placement="top-start"
                        v-else
                    >
                        <p class="td-title text_over_ellipsis">
                            {{ item.name | ellipsis15 }}
                        </p>
                    </el-tooltip>
                    <div
                        class="corner-mark"
                        :class="[
                            item.is_free == 0 ? 'dot-green' : 'dot-orange'
                        ]"
                    >
                        {{ item.is_free == 0 ? "闲置" : "使用中" }}
                    </div>
                    <el-scrollbar
                        :style="{
                            height: 'calc(100% - 40px)'
                        }"
                    >
                        <div class="meeting">
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                v-model="sitem.visible"
                                v-for="(sitem, si) of item.meeting"
                                :key="si"
                            >
                                <meetingRoomPopover
                                    :visible.sync="sitem.visible"
                                    :status="sitem.status"
                                    :data="meetingDetailData"
                                ></meetingRoomPopover>
                                <div
                                    class="td-inner"
                                    :class="{
                                        'td-inner-active':
                                            index == i && sIndex == si
                                    }"
                                    slot="reference"
                                    @click="meetingLookUp(sitem, i, si)"
                                >
                                    <!-- 1-待使用，5-使用中，10-已完成 -->
                                    <p
                                        class="dot"
                                        :class="[
                                            sitem.status == 1
                                                ? 'dot-green'
                                                : sitem.status == 5
                                                ? 'dot-orange'
                                                : 'dot-gray'
                                        ]"
                                    ></p>
                                    <p
                                        class="td-inner-text"
                                        :class="{
                                            'line-through': sitem.status == 10
                                        }"
                                        v-if="item.name.length < 15"
                                    >
                                        {{ sitem.title }}
                                    </p>
                                    <el-tooltip
                                        effect="dark"
                                        :content="sitem.title"
                                        placement="top-start"
                                        v-else
                                    >
                                        <p
                                            class="td-inner-text"
                                            :class="{
                                                'line-through':
                                                    sitem.status == 10
                                            }"
                                        >
                                            {{ sitem.title | ellipsis15 }}
                                        </p>
                                    </el-tooltip>
                                </div>
                            </el-popover>
                        </div>
                    </el-scrollbar>
                    <div class="toolbar">
                        <!-- <p @click="look(item)">查看</p>
                        <p @click="reservation(item)">预定</p>
                        <p @click="edit(item)">编辑</p>
                        <p @click="del(item)">删除</p> -->
                        <p
                            @click="cellDo(btnItem, item)"
                            v-for="(btnItem, i) of item.authority"
                            :key="i"
                        >
                            {{ btnItem.name }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="paging-button">
                <el-button
                    type="primary"
                    icon="el-icon-arrow-left"
                    circle
                    @click="paginationChange('reduce')"
                    :disabled="paginationData.page == 1"
                ></el-button>
                <el-button
                    type="primary"
                    icon="el-icon-arrow-right"
                    circle
                    @click="paginationChange('add')"
                    :disabled="tableData.length < paginationData['per-page']"
                ></el-button>
            </div>
        </div>
        <meetingAdd
            :addVisible.sync="meetingAddVisible"
            :presetValue="presetValue"
        ></meetingAdd>
        <meetingRoomAdd :addVisible.sync="addVisible"></meetingRoomAdd>
        <meetingRoomEdit
            :editVisible.sync="editVisible"
            :cellItem="cellItem"
        ></meetingRoomEdit>
        <meetingRoomDetail
            :detailVisible.sync="detailVisible"
            :cellItem="cellItem"
        ></meetingRoomDetail>
    </div>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import Calendar from "@/comon/components/calendar/calendar.vue";
import meetingRoomPopover from "@/comon/components/meetingRoomPopover.vue";
export default {
    data() {
        return {
            name: "",
            date: "",
            is_free: 99,
            meetingAddVisible: false,
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            index: 0,
            sIndex: 0,
            activeNames: ["1"],
            markDateArr: [],
            agoDayHide: (new Date().getTime() - 3600 * 1000 * 24) / 1000,
            tableData: [],
            meetingDetailData: {},
            cellItem: {},
            presetValue: {},
            paginationData: {
                page: 1,
                "per-page": 18,
                total: ""
            }
        };
    },
    methods: {
        setTdHeight() {
            function getTdWidth() {
                let tdCell = document.querySelector(".td-cell");
                let tdCells = document.querySelectorAll(".td-cell");
                for (let i = 0; i < [...tdCells].length; i++) {
                    [...tdCells][i].style.height =
                        Math.ceil(tdCell.offsetWidth) + "px";
                }
            }
            window.onresize = () => {
                getTdWidth();
            };
            getTdWidth();
        },
        filterMeeting(val) {
            this.is_free === val ? (this.is_free = "") : (this.is_free = val);
            this.meetingRoom();
        },
        lookDetail(data, i, si) {
            this.index = i;
            this.sIndex = si;
            data.visible = !data.visible;
        },
        /**
         * 获取会议室
         * type = init : 覆盖 ; concat : 追加
         */
        meetingRoom() {
            oaApi
                .meetingRoom(
                    {
                        date: this.date,
                        name: this.name,
                        is_free: this.is_free,
                        ...this.paginationData,
                        menu_id: this.menu_id
                    },
                    "get"
                )
                .then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$nextTick(() => {
                            this.setTdHeight();
                        });
                    }
                });
        },
        meetingLookUp(data, i, si) {
            this.index = i;
            this.sIndex = si;
            oaApi.meetingLookUp({ id: data.id }, "get").then(res => {
                if (res.code == 200) {
                    this.meetingDetailData = res.data;
                }
            });
        },
        clickDay(data) {
            this.date = data;
            this.meetingRoom();
        },
        changeDate(data) {
            console.log(data); //左右点击切换月份
        },
        clickToday(data) {},
        look(item) {
            this.detailVisible = true;
            this.cellItem = item;
        },
        reservation(item) {
            this.meetingAddVisible = true;
            this.presetValue = {
                room_id: item.id,
                date: this.date.replace(/\//g, "-")
            };
        },
        edit(item) {
            this.editVisible = true;
            this.cellItem = item;
        },
        del(item) {
            this.$confirm(`确定删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() =>
                    oaApi.meetingRoom("id", "delete", item.id).then(res => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success(`删除成功`);
                                this.meetingRoom();
                            }
                        }
                    })
                )
                .catch(() => {
                    this.$message.info("已取消操作");
                });
        },
        paginationChange(type) {
            if (type == "reduce") {
                this.paginationData.page > 1 ? this.paginationData.page-- : "";
            } else if (type == "add") {
                this.paginationData.page++;
            }
            this.meetingRoom();
        },
        /**
         * 根据td-cell数据循环事件分发
         */
        cellDo(cell, item) {
            if (cell.name == "查看") {
                this.look(item);
            } else if (cell.name == "预定" || cell.name == "预订") {
                this.reservation(item);
            } else if (cell.name == "编辑") {
                this.edit(item);
            } else if (cell.name == "删除") {
                this.del(item);
            }
        }
    },
    components: {
        meetingRoomPopover,
        Calendar,
        meetingAdd: () => import("./meetingRecord/add.vue"),
        meetingRoomAdd: () => import("./meetingRoomSetup/add.vue"),
        meetingRoomEdit: () => import("./meetingRoomSetup/edit.vue"),
        meetingRoomDetail: () => import("./meetingRoomSetup/detail.vue")
    },
    computed: {
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        }
    },
    created() {},
    mounted() {},
    activated() {
        this.date = new Date().toLocaleDateString();
        this.meetingRoom();
    }
};
</script>

<style lang="scss" scoped>
$ebeef5: #ebeef5;
$dedede: #dedede;
.meetingRoomSetup {
    width: 100%;
    min-height: 100%;
    background: #fff;
    display: flex;
    .leftCont {
        width: 250px;
        // border-right: 1px #eee solid;
        padding: 20px;
        box-sizing: border-box;
        height: 100%;
        .status-wrapper {
            margin-top: 20px;
            padding: 20px 0;
            border-top: 1px solid $ebeef5;
            border-bottom: 1px solid $ebeef5;
            .status-title {
                text-align: left;
                margin-bottom: 20px;
                font-size: 13px;
            }
            .status-item {
                display: flex;
                align-items: center;
                font-size: 13px;
                cursor: pointer;
                padding: 5px 0 5px 5px;
                user-select: none;
                border-radius: 2px;
                transition: background 0.4s;
                &:hover {
                    color: #454545;
                    background: $dedede;
                }
                &:not(:last-child) {
                    margin-bottom: 10px;
                }
            }
            .status-item-active {
                background: $dedede;
                /* .dot-orange {
                    background: #fff;
                } */
            }
        }
    }
    .rightCont {
        position: relative;
        width: calc(100% - 250px);
        padding: 20px;
        border-left: 1px #ddd solid;
        .grid-wrap {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            border-left: 1px solid $ebeef5;
            border-top: 1px solid $ebeef5;
            position: relative;
            .td-cell {
                border-bottom: 1px solid $ebeef5;
                border-right: 1px solid $ebeef5;
                vertical-align: top;
                transition: background-color 0.2s ease;
                width: 100%;
                height: 240px;
                padding: 10% 12%;
                // padding: 10% 5% 10% 12%;
                box-sizing: border-box;
                position: relative;
                overflow: hidden;
                font-size: 13px;
                .td-title {
                    margin-bottom: 10px;
                }
                span {
                    .td-inner {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        padding: 4px 6px;
                        .td-inner-text {
                        }
                        &:hover {
                            background: #f5f5f5;
                        }
                    }
                    .td-inner-active {
                        background: $ebeef5;
                    }
                    &:not(:last-child) {
                        display: block;
                        margin-bottom: 4px;
                    }
                }
                .corner-mark {
                    position: absolute;
                    display: block;
                    width: 70px;
                    height: 20px;
                    line-height: 20px;
                    top: 7px;
                    left: -18px;
                    transform: rotate(-45deg);
                    color: #ffffff;
                    font-size: 12px;
                    z-index: 10;
                }
                .meeting {
                    box-sizing: border-box;
                    height: 88%;
                    padding-bottom: 25px;
                }
                .toolbar {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 35px;
                    background: rgba(0, 0, 0, 0.5);
                    color: #ffffff;
                    font-size: 13px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    user-select: none;
                    opacity: 0;
                    transition: opacity 1s;
                    p {
                        cursor: pointer;
                        &:active {
                            opacity: 0.8;
                        }
                    }
                }
                @media screen and (max-width: 1400px) {
                    .td-title {
                        padding: 0 25px;
                    }
                    .toolbar {
                        font-size: 12px;
                        height: 25px;
                    }
                }
                &:hover {
                    background: #f5f5f5;
                    .toolbar {
                        opacity: 1;
                    }
                }
            }
        }
        .paging-button {
            position: absolute;
            left: 50%;
            bottom: 20px;
            transform: translateX(-50%);
        }
    }
    .dot {
        display: inline-block;
        min-width: 6px;
        min-height: 6px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .dot-green {
        background: #00b853;
    }
    .dot-orange {
        background: $theme-color;
    }
    .dot-gray {
        background: $ebeef5;
    }
    .line-through {
        text-decoration: line-through;
    }
}
</style>

<style lang="scss">
.meetingRoomSetup {
    .rightCont {
        .grid-wrap {
            .td-cell {
                .el-scrollbar {
                    .el-scrollbar__wrap {
                        overflow-x: hidden !important;
                    }
                }
            }
        }
    }
}
</style>
